import { render, staticRenderFns } from "./v-render.vue?vue&type=template&id=65970bee&"
import script from "./v-render.vue?vue&type=script&lang=js&"
export * from "./v-render.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports